import "./index.css";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { IRadioControlProps } from "@/controls";
import { RadioControl } from "@/controls";

type IProps = Omit<IRadioControlProps, "value"> & {
  useBoolean?: boolean;
};

export const YesNoRadioControl = (props: IProps) => {
  const { t } = useTranslation();
  const { useBoolean, onChange, name, variant = "card", ...restProps } = props;
  const { setValue } = useFormContext();

  const handleChange = useCallback(
    (value: string) => {
      if (onChange) {
        onChange(value);
      } else if (useBoolean) {
        setValue(name, value === "yes");
      }
    },
    [onChange, useBoolean, setValue, name],
  );

  const effectiveOnChange = useBoolean ? handleChange : onChange;

  return (
    <div className="nuco-yesno-radio-control">
      <RadioControl
        {...restProps}
        name={name}
        value="yes"
        label={t("label.yes")}
        variant={variant}
        onChange={effectiveOnChange}
        message=""
      />
      <RadioControl
        {...restProps}
        name={name}
        value="no"
        label={t("label.no")}
        variant={variant}
        onChange={effectiveOnChange}
        message=""
      />
    </div>
  );
};
